import { defineComponent, ref } from "vue";
import { definePropType } from "@types-vue/props";
import AudioItem from "./audio-item.vue";
export default defineComponent({
    props: {
        resources: {
            type: definePropType(Array),
            default: function() {
                return [];
            }
        }
    },
    components: {
        AudioItem: AudioItem
    },
    setup: function setup(props, param) {
        var emit = param.emit;
        var audioItemRef = ref();
        var handlePlay = function(cb) {
            var audioItems = audioItemRef.value;
            if (Array.isArray(audioItems)) {
                audioItems.forEach(function(item) {
                    return item.pause();
                });
            }
            if (typeof cb === "function") {
                cb();
            }
        };
        var handleAddResource = function(res) {
            emit("addResource", res);
        };
        return {
            audioItemRef: audioItemRef,
            handlePlay: handlePlay,
            handleAddResource: handleAddResource
        };
    }
});
